export enum TrackingState {
  InTransit = 'inTransit',
  ArrivedInCountry = 'arrivedInCountry',
  ClearedCustoms = 'clearedCustoms',
  FinalDeliveryInProgress = 'finalDeliveryInProgress',
  Delivered = 'delivered',
  Cancelled = 'cancelled',
  ExportComplete = 'exportComplete',
}
